import { IS_MAC } from "#app/lib/platform";
// The context module directly, not the module-rail barrel: the Customize
// Navigation dialog (a barrel member) imports this hook's shortcut constant,
// and routing through the barrel would close an import cycle.
import { useModuleRail } from "#app/components/navigation/module-rail/module-rail-context";
import { useHotkey } from "./use-hotkey";
import { AnalyticsContext, NavigationEvent, trackEvent } from "#app/lib/analytics";

/** Keycaps for the compact-mode hotkey. The Option glyph only reads right on
 *  Mac; elsewhere the key is spelled "Alt". Both name the same `altKey`. */
export const COMPACT_MODE_SHORTCUT = IS_MAC ? ["⌥", "M"] : ["Alt", "M"];

/**
 * ⌥/Alt+M toggles the rail's compact mode — the keyboard twin of the
 * Customize Navigation dialog's Compact mode switch, which advertises the
 * chord.
 *
 * The M key is hostile territory for ⌘ chords on a Mac, which is why this is
 * an ⌥ chord: ⇧⌘M is Chrome's profile switcher and ⌘M is the system
 * Minimize — both are handled by the browser/OS before the page sees the
 * key, and both were tried live and eaten.
 */
export function useCompactModeHotkey(): void {
  const { compact, setCompact } = useModuleRail();
  useHotkey({
    code: "KeyM",
    alt: true,
    handler: () => {
      trackEvent({
        context: AnalyticsContext.Navigation,
        event: NavigationEvent.CustomizeNav,
        label: "compact",
        data: { on: !compact, via: "hotkey" },
      });
      setCompact(!compact);
    },
  });
}
